module.exports = __webpack_public_path__ + "img/logo01.fe4fede7.png";